import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class AddToTablePaymentTermList extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/addToPaymentTermList',
      requesterInfo,
    })
  }

  public async addToTablePaymentTermList(Id: number): Promise<any> {
    this.props.url = `${this.props.url}/${Id}`
    return await this.postAsync<any>()
  }
}
